module.exports = __webpack_public_path__ + "img/20200521.a345be17.jpg";